import { Injectable, signal, inject } from '@angular/core';
import { StartService, StandardNameUpdateRecordDTO, NameChangeStatus } from './start.service';

@Injectable({  providedIn: 'root',})
export class StandardNameUpdateStateService {
  private startService = inject(StartService);
  private readonly _updatesInProgress = signal<boolean>(false);
  readonly  updatesInProgress = this._updatesInProgress.asReadonly();


  setUpdatesInProgress(value: boolean) {
    this._updatesInProgress.set(value);
  }

  initFromBackend(updates: StandardNameUpdateRecordDTO[]) {
    if (!updates || updates.length === 0) {
      this.setUpdatesInProgress(false);
      return;
    }
    const isPendingOrFailed = (status?: string) =>
      status === NameChangeStatus.PENDING || status === NameChangeStatus.FAILED;

    const inProgress = updates.some(
      update =>
        isPendingOrFailed(update.mellanlagerUpdates) ||
        isPendingOrFailed(update.lTLUpdates) ||
        isPendingOrFailed(update.grunddataUpdates)
    );

     this.setUpdatesInProgress(inProgress);
  }
}
